import * as React from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

export default function MainMap(props) {
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: 'auto',
        })}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: 'left',
            mx: 3,
            pb: 5,
            mt: { xs: 8, md: 0 },
          }}
        >
        <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
          Map -- This is a placeholder until we get the Google Map API
        </Typography>
        <Grid item xs={12} md={12}>
          <iframe src="https://www.google.com/maps/embed?pb=!1m12!1m10!1m3!1d391473.619763237!2d-83.57328618999843!3d42.51538069340331!2m1!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1742852443046!5m2!1sen!2sus" title="Temporary Map" width="100%" height="800" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </Grid>
        </Stack>
      </Box>
    </Box>
  );
}